<div class="container">
    <div class="skill india">
        <a routerLink="/">
            <img src="../../assets/images/skill-india-logo_1.png" alt="Skill India" class="img-fluid" width="67px"
                height="64px">
        </a>
    </div>
    <div class="Ministry of Skill Development and Entrepreneurship">
        <a>
            <img src="../../assets/images/msde.png" alt="Ministry of Skill Development and Entrepreneurship"
                class="img-fluid" width="194px" height="52px">
        </a>
    </div>
    <div class="naps">
        <a routerLink="/">
            <img src="../../assets/images/naps_logo_final.png" alt="NAPS" class="img-fluid" width="53px" height="64px">
        </a>
    </div>
</div>